var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0491 15.7686L13.504 11.2235L8.95898 15.7686",
    stroke: "#6C7A8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5039 11.2235V21.4499",
    stroke: "#6C7A8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0381 18.4842C24.1463 17.88 25.0218 16.924 25.5264 15.767C26.0309 14.61 26.1358 13.3179 25.8245 12.0947C25.5131 10.8715 24.8033 9.78675 23.807 9.01175C22.8107 8.23674 21.5847 7.81559 20.3225 7.81476H18.8908C18.5468 6.48447 17.9058 5.24947 17.0159 4.20259C16.1259 3.1557 15.0103 2.32419 13.7527 1.77055C12.4952 1.21692 11.1285 0.955574 9.75538 1.00616C8.38229 1.05675 7.03853 1.41796 5.82513 2.06264C4.61173 2.70731 3.56027 3.61867 2.74979 4.72821C1.9393 5.83774 1.3909 7.11657 1.14579 8.46856C0.900692 9.82054 0.965272 11.2105 1.33468 12.5339C1.70409 13.8574 2.36871 15.0798 3.27858 16.1094",
    stroke: "#6C7A8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0491 15.7686L13.504 11.2235L8.95898 15.7686",
    stroke: "#6C7A8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.028b7c0f909146be9c1cec1f02800276.svg";
export { ForwardRef as ReactComponent };